export class Chats {
    constructor(http) {
      this.http = http;
    }

    fetchCredList() {
      return this.http.get(`credentials/`).then(response => response.data);
    }

    fetchUserCredList() {
      return this.http.get(`user_credentials/`).then(response => response.data);
    }

    fetchAccountsFilter(filter_by, page, sort_by, search, page_size, status) {
      return this.http
        .post('accounts', { filter_by, page, sort_by, search, page_size, status })
        .then(response => response);
    }

    fetchUsers(account_id, cred_id) {
      return this.http
        .get(`chat_users/${cred_id}/${account_id}`)
        .then(response => response.data);
    }

    fetchMsgs(account_id, cred_id, user_id) {
      return this.http
        .post('chat_msgs', { account_id, cred_id, user_id})
        .then(response => response);
    }

    saveChatJson(chat_data) {
      return this.http.post('chat_data', { chat_data });
    }
  }
